<template>
    <div>
        <content-item
            :item-key="errorContent"
            bundle-name="Authentication">
        </content-item>
        <b-alert
            v-if="errorMessage"
            show
            variant="warning">
            <b-icon-exclamation-triangle class="mr-3"></b-icon-exclamation-triangle>
            {{ errorMessage }}
        </b-alert>
        <div
            class="border rounded"
            style="width: 373px; padding: 24px;">
            <h2 style="color: #106282;">
                Link an Existing Profile
            </h2>
            <b-form
                style="gap: 24px;"
                class="d-flex flex-column"
                @submit="signIn">
                <div
                    class="d-flex flex-column"
                    style="gap: 16px">
                    <div>
                        <div class="d-flex justify-content-between">
                            <label for="username">Username</label>
                            <a href="/site/vaccn/main/public/account-reset?feature=forgot-password">Forgot Username?</a>
                        </div>
                        <b-form-input
                            id="username"
                            v-model="userName"></b-form-input>
                    </div>
                    <div>
                        <div class="d-flex justify-content-between">
                            <label for="password">Password</label>
                            <a href="/site/vaccn/main/public/account-reset?feature=forgot-password">Forgot Password?</a>
                        </div>
                        <b-form-input
                            id="password"
                            v-model="password"
                            type="password"></b-form-input>
                    </div>
                </div>
                <p class="text-center">
                    Don't have an account? <a href="/site/vaccn/main/public/registration">Register now.</a>
                </p>
                <b-button
                    style="width: fit-content;"
                    class="align-self-end py-3 px-4"
                    type="submit"
                    variant="primary">Link Profile</b-button>
            </b-form>
            <hr />
            <a
                v-b-modal.privacy-modal
                href="javascript:void(0)">Privacy</a>
            <b-modal
                id="privacy-modal"
                ok-only>
                <h3>Privacy & Legal Information</h3>
                <content-item
                    item-key="PRIVACY_NOTICE"
                    bundle-name="Authentication">
                </content-item>
            </b-modal>
        </div>
        <b-modal
            id="new-password-modal"
            title="Reset Password"
            ok-title="Reset &amp; Sign In"
            size="lg"
            @ok="signIn">
            <content-item
                :item-key="newPasswordMessage"
                bundle-name="Authentication">
            </content-item>
            <b-container style="display: flex; flex-direction: row; justify-content: space-between;">
                <b-form
                    style="gap: 24px; width: 30%"
                    class="d-flex flex-column">
                    <div
                        class="d-flex flex-column"
                        style="gap: 16px">
                        <div>
                            <div class="d-flex justify-content-between">
                                <label for="newPassword">New Password <span style="color: red;">*</span></label>
                            </div>
                            <b-form-input
                                id="newPassword"
                                v-model="newPassword"
                                type="password"></b-form-input>
                        </div>
                        <div>
                            <div class="d-flex justify-content-between">
                                <label for="newPasswordConfirmation">
                                    Confirm Password <span style="color: red;">*</span>
                                </label>
                            </div>
                            <b-form-input
                                id="newPasswordConfirmation"
                                v-model="newPasswordConfirmation"
                                type="password"></b-form-input>
                        </div>
                    </div>
                </b-form>
                <div style="max-width: 65%;">
                    <content-item
                        item-key="AUTHENTICATION_RACF_ACCOUNT_RESET_RIGHT"
                        bundle-name="Authentication">
                    </content-item>
                </div>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
export default {
    extends: PgbaBaseComponent,
    props: {
        setTab: {
            type: Function,
            required: true
        }
    },
    data: () => {
        return {
            userName: '',
            password: '',
            newPassword: '',
            newPasswordConfirmation: '',
            errorContent: '',
            errorMessage: '',
            newPasswordMessage: ''
        };
    },
    methods: {
        ...mapActions('selectProfile', [
            'authenticate'
        ]),
        signIn(event) {
            if (event.type == 'submit') {
                event.preventDefault();
            }
            this.showLoading();
            this.authenticate({
                userName: this.userName,
                password: this.password,
                newPassword: this.newPassword,
                newPasswordConfirmation: this.newPasswordConfirmation
            })
                .then((data) => {
                    this.errorContent = '';
                    this.errorMessage = '';
                    const {
                        authenticationSuccessful,
                        compromised,
                        redirectPath,
                        constituentType,
                        passwordExpired,
                        newPasswordInvalid
                    } = data;
                    if (!authenticationSuccessful) {
                        this.errorContent = 'SIGN_IN_ERROR_MSG';
                        if (compromised) {
                            if (constituentType !== 'provider' && constituentType !== 'prime') {
                                this.errorContent = `AUTHENTICATION_ACCOUNT_LOCKED`;
                                return;
                            }
                            this.errorContent = `${constituentType.toUpperCase()}_ACCOUNT_LOCKED`;
                            return;
                        }
                        if (passwordExpired && constituentType === 'prime') {
                            this.errorContent = '';
                            this.displayNewPasswordModal('RACF_PASSWORD_EXPIRED');
                            return;
                        }
                        if (newPasswordInvalid && constituentType === 'prime') {
                            this.errorContent = '';
                            this.displayNewPasswordModal('AUTHENTICATION_NEW_PASSWORD_INVALID');
                            return;
                        }
                        if (redirectPath) {
                            // TODO: in the refresh we want to redirect to registration and display this message there
                            const queryParams = new URLSearchParams(redirectPath.split('?')[1]);
                            if (queryParams.has('message') && queryParams.get('message') === 'optum-linked') {
                                this.errorMessage = 'The username you submitted is already linked to another '
                                    + 'One Healthcare ID account. Please register a new profile.';
                                this.errorContent = '';
                                return;
                            }
                            this._redirect(redirectPath);
                        }
                        return;
                    }
                    this._redirect(redirectPath);
                })
                .finally(() => {
                    this.hideLoading();
                });
        },
        _redirect(url) {
            window.location.href = url;
        },
        displayNewPasswordModal(message) {
            this.newPasswordMessage = message;
            this.$bvModal.show('new-password-modal');
        }
    }
};
</script>